import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import { MemorySymbolV1 } from '../MemorySymbolV1';
import { BLOCKS } from '../../shared/memory-map-data';
import { SIGNS, SIGN_VALUES, getMapLine, getMemoryMap, getUserName } from '../../shared/memory-map-helpers';
import styles from './MemoryMapSlide.css';

const SYMBOL_SIZE = 80;

function MemoryMapSlide({ results, spriteVersion }) {
    const map = getMemoryMap(results.userResponses);
    const name = getUserName(results.userResponses);

    return (
        <section className={styles.form}>
            <div className={styles.head}>
                <h1 className={styles.heading}>{name ? `${name}’s` : 'Your'} Memory Map</h1>
                <div className={styles.carry}>
                    <p className={styles.number}>{map.carry}</p>
                    <p className={styles.caption}>memories you’re still carrying</p>
                </div>
            </div>
            <ul className={styles.chapters}>
                {BLOCKS.map((block, index) => {
                    const chapter = map.ch[index];
                    const [title, line] = getMapLine(index, chapter);

                    return (
                        <li className={styles.chapter} key={block.key}>
                            <div className={styles.chapterText}>
                                <p className={styles.eyebrow}>{`${block.chapter}. ${block.short}`}</p>
                                <div className={styles.verdict}>
                                    <p className={styles.verdictTitle}>{title}</p>
                                    <p className={styles.verdictLine}>{line}</p>
                                </div>
                            </div>
                            <div className={styles.symbol}>
                                <MemorySymbolV1
                                    type={SIGNS[index]}
                                    value={SIGN_VALUES[SIGNS[index]][chapter.state - 1]}
                                    size={SYMBOL_SIZE}
                                />
                            </div>
                        </li>
                    );
                })}
            </ul>
            <div className={styles.unsaid}>
                <p className={styles.unsaidLabel}>Unsaid</p>
                <p className={styles.unsaidText}>{map.unsaid}</p>
            </div>
            <div className={styles.pitch}>
                <p className={styles.pitchTitle}>{`In 3 minutes, ${map.total} memories came back. That’s a tiny piece of what’s in there.`}</p>
                <div className={styles.two}>
                    <div className={styles.heavy}>
                        <EmojiIcon name='cloud-with-lightning' version={spriteVersion} />
                        <p className={styles.pitchTitle}>If it’s heavy</p>
                        <p className={styles.pitchNote}>Say it, finally.</p>
                    </div>
                    <div className={styles.good}>
                        <EmojiIcon name='sun' version={spriteVersion} />
                        <p className={styles.pitchTitle}>If it’s good</p>
                        <p className={styles.pitchNote}>Keep it before it blurs.</p>
                    </div>
                </div>
                <p className={styles.pitchNote}>Either way, you get to see your whole story from the outside, maybe for the first time.</p>
            </div>
        </section>
    );
}

MemoryMapSlide.propTypes = {
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired,
    spriteVersion: PropTypes.string.isRequired
};

export {
    MemoryMapSlide
};
